import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
function colClass(breakpoint, span) {
    if (span == null || span === '') {
        return '';
    }
    const prefix = breakpoint ? `${breakpoint}:` : '';
    return `${prefix}col-${span}`;
}
export const PCol = ({ children, sm, md, lg, xl, col, className, style }) => {
    const classes = [
        col != null ? colClass(undefined, col) : 'col',
        colClass('sm', sm),
        colClass('md', md),
        colClass('lg', lg),
        colClass('xl', xl),
        className ? String(className) : '',
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsx("div", { style: style, className: classes, children: children }));
};
export default PCol;
